import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { BookingInfo } from "@/types/components";

export const useHasPendingBookings = () => {
  const cookies = useCookies();

  const [isLoading, setIsLoading] = useState(true);
  const [pendingBookingsState, setPendingBookingsState] = useState<
    BookingInfo[]
  >([]);

  const getIdsFromCookies = () => {
    //for each key in cookies, check if it is a number of 4 digits and add it to the array
    const pendingBookings = [];
    for (const key in cookies[0]) {
      if ((key.length === 4 || key.length === 5) && !isNaN(Number(key))) {
        pendingBookings.push(cookies[0][key]);
      }
    }
    setPendingBookingsState(pendingBookings);
    setIsLoading(false);
  };
  useEffect(() => {
    getIdsFromCookies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    pendingBookingsState,
    isLoading,
  };
};
